import { PasswordStrength } from './enums.js';
import { defineComponent } from '@vue/composition-api';

/**
 * @deprecated Use SdsPassword
 */
var script = defineComponent({
    name: 'SbPasswordStrengthMeter',
    props: {
        passwordStrength: {
            type: Number,
            required: true,
        },
    },
    computed: {
        parsedPasswordStrength: function () {
            var _a;
            var strength = (_a = {},
                _a[PasswordStrength.Strong] = {
                    meterStyle: 'sb-password-strength-meter__fill--strong',
                    message: 'auth.password.strength.strong',
                },
                _a[PasswordStrength.Good] = {
                    meterStyle: 'sb-password-strength-meter__fill--good',
                    message: 'auth.password.strength.good',
                },
                _a[PasswordStrength.Weak] = {
                    meterStyle: 'sb-password-strength-meter__fill--weak',
                    message: 'auth.password.strength.weak',
                },
                _a)[this.passwordStrength];
            if (!strength) {
                throw new Error('Unknown strength');
            }
            return strength;
        },
    },
});

export default script;
